import React, { useState, useEffect } from "react";

import { Album } from 'app/api/types';

import "./styles.scss";

interface IProps {
  album: Album;
  isActive: boolean;
  onSubmit: (data: Album) => void;
}

const EditAlbumForm: React.FC<IProps> = props => {
  const [name, setName] = useState(props.album.name);
  const [description, setDescription] = useState(props.album.description);
  const [errorStyle, setErrorStyle] = useState({
    name: ""
  });

  const handleChange = (e: any) => {
    e.target.name === "name" && setName(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (name.length > 1)
      props.onSubmit({
        ...props.album,
        description,
        name,
      });
  };

  useEffect(() => {
    setErrorStyle({
      name: name && name.length > 1 ? "" : "edit-phrase__input_error"
    });
  }, [name]);

  return (
    <form
      className={`edit-phrase-album__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="phrase" className="edit-phrase__label">
        название альбома
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.name}`}
        type="text"
        placeholder={name}
        name="name"
        value={name}
        onChange={handleChange}
        autoComplete="off"
      />
      <label htmlFor="meaning" className="edit-phrase__label">
        краткое описание
      </label>
      <textarea
        className={"edit-phrase__input"}
        placeholder={"Напишите краткое описание альбома"}
        name="description"
        value={description}
        onChange={handleChange}
        autoComplete="off"
      />
      <button className="edit-phrase__submit">cохранить</button>
    </form>
  );
};

export default EditAlbumForm;
